import type { AnswerRecord } from './records';
import type { TenantDatabase } from './tenant-db';

/**
 * Een antwoord dat de server op een andere plek zette: dezelfde `answer_uuid`,
 * maar een andere vraag of een ander bereik. Dat gebeurt als de opname naar een
 * nieuwe versie van de vragenlijst verhuist - de vragen krijgen daar nieuwe id's.
 *
 * Een foto hangt aan (vraag, bereik), niet aan het antwoord-uuid: dat wordt pas bij
 * de upload opgezocht. Blijft de foto op de oude plek staan, dan wacht hij voor
 * altijd op een antwoord dat daar niet meer is en verdwijnt hij uit beeld. Dus gaan
 * de foto's mee, ook die nog geüpload moeten worden.
 *
 * Alleen Dexie-werk, binnen de transactie van de aanroeper (met `photos` erin).
 */
export async function followAnswer(
    db: TenantDatabase,
    previous: AnswerRecord | undefined,
    next: AnswerRecord,
): Promise<void> {
    if (
        !previous ||
        previous.slot === next.slot ||
        previous.inspectionUuid !== next.inspectionUuid
    ) {
        return;
    }

    await db.photos
        .where('[inspectionUuid+slot]')
        .equals([previous.inspectionUuid, previous.slot])
        .modify({ questionId: next.questionId, multiScope: [...next.multiScope], slot: next.slot });
}
